module.exports = __webpack_public_path__ + "media/images/bar_four-45f0a182cf163bcd38a8e457033f6fdc.png";